<lib-app-layout [appTitle]="title">
  <app-menu></app-menu>
  <router-outlet></router-outlet>
</lib-app-layout>